import { useState } from "react";
import { Star, CheckCircle2, Circle } from "lucide-react";
import { storage } from "@/lib/storage";

export const BookmarkButton = ({ slug, size = "md" }) => {
  const [active, setActive] = useState(() => storage.isBookmarked(slug));
  const dim = size === "sm" ? "w-8 h-8" : "w-10 h-10";
  const icon = size === "sm" ? "w-4 h-4" : "w-5 h-5";
  return (
    <button
      data-testid={`bookmark-toggle-${slug}`}
      aria-label="Toggle bookmark"
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        const next = storage.toggleBookmark(slug);
        setActive(next);
      }}
      className={`brut-border brut-shadow-sm brut-hover ${dim} flex items-center justify-center ${
        active ? "bg-brut-yellow" : "bg-background"
      }`}
    >
      <Star
        className={`${icon} ${active ? "fill-foreground" : ""}`}
        strokeWidth={2.5}
      />
    </button>
  );
};

export const CompleteToggle = ({ slug, onChange }) => {
  const [done, setDone] = useState(() => storage.isCompleted(slug));
  return (
    <button
      data-testid={`complete-toggle-${slug}`}
      onClick={() => {
        const next = storage.toggleCompleted(slug);
        setDone(next);
        onChange?.(next);
      }}
      className={`w-full sm:w-auto inline-flex items-center justify-center gap-3 px-6 py-4 brut-border brut-shadow brut-hover font-bold uppercase tracking-wider text-sm transition-colors ${
        done ? "bg-brut-yellow" : "bg-background"
      }`}
    >
      {done ? (
        <CheckCircle2 className="w-6 h-6" strokeWidth={2.5} />
      ) : (
        <Circle className="w-6 h-6" strokeWidth={2.5} />
      )}
      {done ? "Marked Complete" : "Mark as complete"}
    </button>
  );
};
